var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.59 0.590976C10.21 0.210976 9.7 0.000976562 9.17 0.000976562H2C0.9 0.000976562 0 0.900977 0 2.00098V18.001C0 19.101 0.89 20.001 1.99 20.001H14C15.1 20.001 16 19.101 16 18.001V6.83098C16 6.30098 15.79 5.79098 15.41 5.42098L10.59 0.590976ZM11 16.001H5C4.45 16.001 4 15.551 4 15.001C4 14.451 4.45 14.001 5 14.001H11C11.55 14.001 12 14.451 12 15.001C12 15.551 11.55 16.001 11 16.001ZM11 12.001H5C4.45 12.001 4 11.551 4 11.001C4 10.451 4.45 10.001 5 10.001H11C11.55 10.001 12 10.451 12 11.001C12 11.551 11.55 12.001 11 12.001ZM9 6.00098V1.50098L14.5 7.00098H10C9.45 7.00098 9 6.55098 9 6.00098Z",
    fill: "#94A3B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyJob);
export default __webpack_public_path__ + "static/media/my-job.0d3676e831c480c5c4bbc2372c2cbf77.svg";
export { ForwardRef as ReactComponent };